import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `material`,
    title: `Качество`,
    content: {
      description: `<p>Набор крышка-дно на 16 конфет.<br>Размер 180х150х20 мм / Вес: 160 г<br>Наполнение: 16 шоколадных конфет с ореховой начинкой.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
